import {Component, computed, HostBinding, inject, input} from '@angular/core';
import {RouterLink} from "@angular/router";
import {Lottery} from "../../model/lottery";
import {Preferences} from "../../model/user";
import {BoroughToTextPipe} from "../../pipes/borough-to-text.pipe";
import {DialogService} from "primeng/dynamicdialog";
import {
  ApartmentDetailPageComponent
} from "../../pages/apartments-tab/apartment-detail-page/apartment-detail-page.component";
import {HomeyImageDirective} from "../../directives/homey-image.directive";

@Component({
  selector: 'homey-lottery-list-item',
  standalone: true,
  imports: [
    RouterLink,
    BoroughToTextPipe,
    HomeyImageDirective
  ],
  templateUrl: './lottery-list-item.component.html',
})
export class LotteryListItemComponent {
  @HostBinding('class') readonly hostClass = 'flex items-center gap-2 relative flex-grow focus-visible:border-cyan-500 min-w-0';
  public readonly openInPopup = input(false);
  public readonly gray = input(false);
  public readonly apartment = input.required<Lottery>();
  public readonly preferences = input<Preferences>();
  public readonly baseRoute = input<string>('.');
  public readonly showNeighbourhoodAndBorough = input<boolean>(true);
  private readonly dialogService = inject(DialogService);
  protected readonly perfectFit = computed(
    () => {
      const preferences = this.preferences();
      const apartment = this.apartment();

      if (preferences === undefined) {
        return false;
      }

      return this.isRoomSizePreferred(apartment, preferences) && this.isBoroughPreferred(apartment, preferences);
    }
  )

  private isRoomSizePreferred = (apartment: Lottery, preferences: Preferences) => {
    return apartment.unitTypes.some(
      unitType => {
        switch (unitType.unitType) {
          case 'studio':
            return preferences.room.includes('studio');
          case "one-bedroom":
            return preferences.room.includes('one-bedroom');
          case "two-bedrooms":
            return preferences.room.includes('two-bedrooms');
          case "three-bedrooms":
            return preferences.room.includes('three-bedrooms');
          case "four-bedrooms":
            return preferences.room.includes('four-or-more-bedrooms');
          case "five-bedrooms":
            return preferences.room.includes('four-or-more-bedrooms');
          case "six-bedrooms":
            return preferences.room.includes('four-or-more-bedrooms');
        }
      }
    )
  }

  private isBoroughPreferred(apartment: Lottery, preferences: Preferences) {
    return preferences.borough.includes(apartment.borough);
  }

  protected openPopup() {
    this.dialogService.open(
      ApartmentDetailPageComponent,
      {
        showHeader: true,
        closable: true,
        modal: true,
        focusOnShow: false,
        styleClass: 'no-header-padding-dialog',
        width: 'calc(min(100vw - 10px, 500px))',
        height: 'calc(100vh - 10px)',
        inputValues: {
          lotteryId: this.apartment().slug ?? this.apartment().id,
        }
      }
    );
  }
}
